import { Instagram, Youtube, MessageCircle } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const COLS = [
  {
    t: "Leistungen",
    items: [
      { label: "Produktion", href: "#produktion" },
      { label: "Content", href: "#content" },
      { label: "Werbung", href: "#werbung" },
      { label: "Digital & Web", href: "#digital" },
    ],
  },
  {
    t: "Studio",
    items: [
      { label: "Portfolio", href: "#portfolio" },
      { label: "Über uns", href: "#about" },
      { label: "Prozess", href: "#process" },
      { label: "Kontakt", href: "#kontakt" },
    ],
  },
];

const LEGAL = [
  { label: "Impressum", to: "/impressum" },
  { label: "Datenschutz", to: "/datenschutz" },
  { label: "AGB", to: "/agb" },
  { label: "Widerruf & Stornierung", to: "/stornierung" },
];

export const Footer = ({ onScrollTo }) => {
  const navigate = useNavigate();

  const goSection = (href) => {
    if (onScrollTo) onScrollTo(href);
    else navigate("/");
  };
  const goTop = () => {
    if (onScrollTo) onScrollTo("#top");
    else navigate("/");
  };

  return (
    <footer data-testid="footer" className="relative border-t border-white/10 pt-20 pb-10">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <button onClick={goTop} className="text-left" aria-label="Gold Media Studio">
              <img src="/logo.png" alt="Gold Media Studio" className="h-11 w-auto" />
            </button>
            <p className="mt-6 font-body text-[#71717a] max-w-sm leading-relaxed">
              Creative Production & Werbeagentur. Produktion, Content und Werbung aus einer Hand.
            </p>
            <p className="mt-6 font-display uppercase tracking-[0.2em] text-xs text-[#a1a1aa]">Hamburg, Deutschland</p>
            <div className="mt-6 flex gap-4">
              {[Instagram, Youtube, MessageCircle].map((Icon, i) => (
                <a key={i} href="#" data-testid={`social-${i}`} aria-label="Social" className="w-11 h-11 border border-white/10 flex items-center justify-center text-[#a1a1aa] hover:border-[#d4c4a8] hover:text-[#d4c4a8] transition-colors duration-400">
                  <Icon size={18} strokeWidth={1.4} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((c) => (
            <div key={c.t} className="lg:col-span-2">
              <p className="font-display uppercase tracking-[0.2em] text-xs text-[#71717a] mb-5">{c.t}</p>
              <ul className="space-y-3">
                {c.items.map((it) => (
                  <li key={it.label}>
                    <button onClick={() => goSection(it.href)} className="font-body text-sm text-[#a1a1aa] hover:text-[#fafafa] link-underline transition-colors">{it.label}</button>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <p className="font-display uppercase tracking-[0.2em] text-xs text-[#71717a] mb-5">Rechtliches</p>
            <ul className="space-y-3">
              {LEGAL.map((it) => (
                <li key={it.to}>
                  <Link to={it.to} data-testid={`legal-link-${it.to.replace("/", "")}`} className="font-body text-sm text-[#a1a1aa] hover:text-[#fafafa] link-underline transition-colors">{it.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4 text-xs text-[#52525b] font-body">
          <p>© {new Date().getFullYear()} Gold Media Studio. Alle Rechte vorbehalten.</p>
          <p>Videoproduktion · Filmproduktion · Werbeagentur · Hamburg</p>
        </div>
      </div>
    </footer>
  );
};
